import { render, staticRenderFns } from "./Wp_join_robot_list_Sheet.vue?vue&type=template&id=badc670c&scoped=true&"
import script from "./Wp_join_robot_list_Sheet.vue?vue&type=script&lang=js&"
export * from "./Wp_join_robot_list_Sheet.vue?vue&type=script&lang=js&"
import style0 from "./Wp_join_robot_list_Sheet.vue?vue&type=style&index=0&id=badc670c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badc670c",
  null
  
)

export default component.exports